/*
 * @Descripttion:
 * @version: v1.0
 * @Author: baidongsheng
 * @Date: 2021-09-17 17:24:01
 * @LastEditors: baidongsheng
 * @LastEditTime: 2021-10-22 16:42:38
 */
export default {
    'loading': '努力加载中',
    'trust': '【{name}委托】',
};
